import { blueGrey } from '@material-ui/core/colors';

const styles = (theme) => ({
  marginTop: {
    marginTop: '24px',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  root: {
    flexGrow: 1,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(10),
    right: theme.spacing(6),
  },
  blue: {
    color: theme.palette.getContrastText(blueGrey[500]),
    backgroundColor: blueGrey[500],
    fontFamily: ['Roboto'],
  },
  chip: {
    margin: theme.spacing(0.5),
  },
});

export default styles;
